import React from "react";
import {observer} from "mobx-react";
import {FormFields} from "../../../../models/forms/form-field.interface";
import {IBookingSearchCommonFields} from "./booking-search-common-fields.interface";
import {StringFieldEditorComponent} from "../../../../components/forms/string-field/string-field-editor.component";
import {
    StationDropDownComponent
} from "../../../../components/flight-search/stations-selection/drop-down/station-drop-down.component";
import {useServices} from "../../../../hooks/use-services.hook";
import {
    DateFieldEditorWithInputMaskComponent,
    DateFieldMask
} from "../../../../components/forms/date-time/date-field-editor-with-input-mask.component";

interface CommonSearchFieldsComponentProps {
    fields: FormFields<IBookingSearchCommonFields>;
}
export const BookingSearchCommonFieldsComponent: React.FC<CommonSearchFieldsComponentProps> = observer((props) => {
    const services = useServices();
    const fields = props.fields;

    const getStations = () => {
        return services.stations.getAllStationsWithoutMacs();
    }

    return (
        <>
            <StationDropDownComponent field={fields.origin}
                                      getStations={getStations}
                                      placeholder={""}
                                      inputStyle={"outsideBorder"}
                                      showClearButton={true}
                                      popperOptions={{
                                          sameWidthAsElementToAttach: true
                                      }}/>
            <StationDropDownComponent field={fields.destination}
                                      getStations={getStations}
                                      placeholder={""}
                                      inputStyle={"outsideBorder"}
                                      showClearButton={true}
                                      popperOptions={{
                                          sameWidthAsElementToAttach: true
                                      }}/>
            <StringFieldEditorComponent field={fields.flightNumber} showClearButton={true}/>

            <DateFieldEditorWithInputMaskComponent field={fields.departureDate} mask={DateFieldMask.DDMMYYYY} showClearButton={true}/>
        </>
    )
})